import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { SystemSettingService } from '@app/api/systemsettting.service';
@Component({
  selector: 'meu-footer-group-item',
  templateUrl: './footer-group-item.component.html',
  styleUrls: ['./footer-group-item.component.scss'],
  animations: [
    trigger('expand', [
      state(
        'closed',
        style({
          maxHeight: '0px',
          opacity: 0,
          overflow: 'hidden',
        })
      ),
      state(
        'open',
        style({
          maxHeight: '1000px',
          opacity: 1,
          overflow: 'hidden',
        })
      ),
      transition('closed <=> open', animate('150ms ease')),
    ]),
  ],
})
export class FooterGroupItemComponent implements OnInit, OnChanges {
  lstChild;
  @Input() data: any; // Nhận data từ parent
  @Input() lang: 'vi' | 'en' | 'zh' = 'vi';
  @Output() onEditRequest = new EventEmitter<{
    title: string;
    type: string;
    id: any;
    lang: string;
  }>();
  @Output() createRequest = new EventEmitter<{
    title: string;
    type: string;
    id: any;
    lang: string;
  }>();

  @Output() onDelete = new EventEmitter<{ item: any; type: string }>();

  isOpen = false;
  openMenuId: string | null = null;

  constructor(private system: SystemSettingService) {}

  ngOnInit(): void {
    this.getChildren();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      // Reset state when data changes
      this.isOpen = false;
      this.openMenuId = null;
    }
  }
  toggleChild() {
    this.isOpen = !this.isOpen;
  }

  toggleChildClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleChild();
  }

  toggleMenu(event: MouseEvent, id: string) {
    event.stopPropagation();
    this.openMenuId = this.openMenuId === id ? null : id;
  }

  getChildren() {
    this.system.apiSystemSettingGet(`parent_id==${this.data.id}`).subscribe((res) => {
      if (res.success) {
        this.lstChild = res.data.collection[0].children;
     
      }
    });
  }

  editGroup(id) {
  
    const eventData = {
      title: 'Chỉnh sửa nhóm',
      type: 'updateGroup',
      id: this.data.id,
      lang: this.lang,
    };
 
    this.onEditRequest.emit(eventData);
  }

  editChild(childId: string) {
    
    const eventData = {
      title: 'Chỉnh sửa mục con',
      type: 'updateGroupChild',
      id: childId,
      lang: this.lang,
    };

    this.onEditRequest.emit(eventData);
  }

  createGroup(idParrent) {
   
    const eventData = {
      title: 'Tạo mới mục con',
      type: 'newGroupChild',
      id: idParrent,
      lang: this.lang,
    };
  
    this.createRequest.emit(eventData);
  }

  handleDelete(type: string, item?: any) {
 
    this.onDelete.emit({ item: item || this.data, type });
  }
}
